import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export function MoreFilters({ filters, updateState }) {
    const sortOptions = [
        {
            id: '-created_at',
            name: 'Newest First',
        },
        {
            id: '+created_at',
            name: 'Oldest First',
        },
        {
            id: '-cdata.total_likes',
            name: 'Most Liked',
        },
        {
            id: '+cdata.total_likes',
            name: 'Least Liked',
        },
    ];

    const handleChange = (event) => {
        const name = event.target.name;
        let key = "";
        if (name === "notShared") {
            key = "null___already_shared_with_these_clients";
        }
        else if (name === "Shared") {
            key = "notnull___shared_with_clientid";
        }
        else if (name === "handedClient") {
            key = "equalto___handed_over_to_client";
        }
        else if (name === "handedEmployee") {
            key = "equalto___handed_over_to_an_employee_for_internal_use";
        }
        // else if (name === "handedEmployeeShowing") {
        //     key = "equalto___handed_over_to_an_employee_for_showcasing";
        // }
        // else if (name === "notLiveCollection") {
        //     key = "null___shared_with_clientid";
        // }
        else if(name === "notDraftLiveCollection") {
            key = "null___collection_code"
        }         else if(name === "notDispatchOrOutOnLoan") {
            key = "notDispatchOrOutOnLoan"
        } else if(name === "neverLiked") {
            key = "neverLiked"
        } else {
            return;
        }
        updateState({ [key]: event.target.checked });
    };

    const handleSortChange = (event) => {
        updateState({ sortBy: event.target.value });
    };

    return (
        <div className='attirubutes-filter-container'>
            <div className='input-container'>
                <Box>
                    <FormControl size="small" fullWidth>
                        <InputLabel id="sort-select-label">Sort By</InputLabel>
                        <Select
                            labelId="sort-select-label"
                            id="sort-select"
                            value={filters.sortBy || '-created_at'}
                            label="Sort By"
                            onChange={handleSortChange}
                        >
                            {sortOptions.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>
            <FormControl component="fieldset" variant="standard" sx={{ mb: 2 }}>
                <FormGroup>
                    <FormControlLabel
                        control={<Switch checked={filters["null___already_shared_with_these_clients"]} onChange={handleChange} name="notShared" />}
                        label="Never been part of a collection shared with a client" />
                    <FormControlLabel
                        control={<Switch checked={filters["notnull___shared_with_clientid"]} onChange={handleChange} name="Shared" />}
                        label="Has been shared with a client" />
                    <FormControlLabel
                        control={<Switch checked={filters["equalto___handed_over_to_client"]} onChange={handleChange} name="handedClient" />}
                        label="Handed over to a client" />
                    <FormControlLabel
                        control={<Switch checked={filters["equalto___handed_over_to_an_employee_for_internal_use"]} onChange={handleChange} name="handedEmployee" />}
                        label="Handed over to an employee" />
                    {/* <FormControlLabel
                        control={<Switch checked={filters["equalto___handed_over_to_an_employee_for_showcasing"]} onChange={handleChange} name="handedEmployeeShowing" />}
                        label="Handed over to an employee for showing" /> */}
                    {/* <FormControlLabel
                        control={<Switch checked={filters["null___shared_with_clientid"]} onChange={handleChange} name="notLiveCollection" />}
                        label="Do not show the ones which are part of a live collection" /> */}
                    <FormControlLabel
                        control={<Switch checked={filters["null___collection_code"]} onChange={handleChange} name="notDraftLiveCollection" />}
                        label="Do not show the ones which are part of a Live and Draft (Available) collection" />
                                    <FormControlLabel
                    control={<Switch checked={filters["notDispatchOrOutOnLoan"]} onChange={handleChange} name="notDispatchOrOutOnLoan" />}
                    label="Do not show the ones who are dispatched and out on loan" />
                <FormControlLabel
                    control={<Switch checked={filters["neverLiked"]} onChange={handleChange} name="neverLiked" />}
                    label="Swatches that are never liked" />
                </FormGroup>
            </FormControl>
        </div>
    );
}
